"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.VERSION=void 0;const VERSION=exports.VERSION=process.env.REACT_APP_PULSE_VERSION;